import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

export const BASE_CLASS = `${PAGE_BASE_CLASS}-description`

export const COLLAPSED_LINES = 4

// Keep in sync with $trsdu-mt-detail-new-description-text in index.scss.
export const ANIMATION_DURATION = 300
